import { useState } from "react";
import ReportDialog from "@/components/ReportDialog";
import { Flag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function ReportButton({ targetType, targetId, targetTitle, className = "", size = "sm", label = "Report" }) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();

  if (!targetId) return null;

  const click = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast.info("Sign in to send a report");
      nav("/login");
      return;
    }
    setOpen(true);
  };

  const base = "inline-flex items-center gap-1.5 rounded-full border border-transparent text-[#5C5C5C] hover:text-[#C05A3D] hover:border-[#C05A3D] transition";
  const sz = size === "icon" ? "w-8 h-8 justify-center" : "px-3 h-8 text-xs";

  return (
    <>
      <button type="button" onClick={click} className={`${base} ${sz} ${className}`} data-testid={`report-btn-${targetType}-${targetId}`} aria-label={`Report ${targetType}`}>
        <Flag className="w-3.5 h-3.5" />
        {size !== "icon" && <span>{label}</span>}
      </button>
      <ReportDialog open={open} onOpenChange={setOpen} targetType={targetType} targetId={targetId} targetTitle={targetTitle} />
    </>
  );
}
